import { Injectable } from '@angular/core';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { contextTokens } from '@monsido/ng2/services/request-auxiliary/request-auxiliary.service';
import { GetMe, UpdateMePayload } from '@client/app/feature-modules/navigation/profile/edit-profile/types/profile.type';

@Injectable({
    providedIn: 'root',
})
export class MeRepo {
    constructor (
        private readonly apiService: ApiService,
    ) {}

    get (): Promise<GetMe> {
        return this.apiService.get<GetMe>('me');
    }

    update (data: Partial<UpdateMePayload>): Promise<GetMe> {
        return this.apiService.patch<GetMe>('me', data, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }
}
